import { render, staticRenderFns } from "./TaskLists.vue?vue&type=template&id=7d2f055d"
import script from "./TaskLists.vue?vue&type=script&lang=js"
export * from "./TaskLists.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports